import React from 'react';
import { StyleSheet } from 'react-native';
import { CardView, rem } from 'design-system';
import UpgradeButton from 'design-system/UpgradeButton';
const UpgradeToSeeMoreCard = ({ onPressUpgrade, withPadding = true, }) => (<CardView withPadding={withPadding} style={withPadding ? styles.upgradeCard : null}>
    <UpgradeButton onCard chipText="Recurring payments" text="Get the full breakdown of your subscriptions and bills with Emma Pro or Ultimate" onPress={onPressUpgrade}/>
  </CardView>);
const styles = StyleSheet.create({
    upgradeCard: {
        paddingVertical: rem(32),
    },
});
export default UpgradeToSeeMoreCard;
